export class DeviceConfigParams {
    DeviceGuid: string = "";
}